export const HEATING_COST_PER_M2 = 15 / 12;

export const COMMUTE_MIX_CAR_INDEX = 0;
export const COMMUTE_MIX_TRAIN_INDEX = 1;
export const COMMUTE_MIX_PUBLIC_TRANSPORT_INDEX = 2;
export const COMMUTE_MIX_BIKE_INDEX = 3;
export const COMMUTE_MIX_FOOT_INDEX = 4;

// in g CO2 / km
export const COMMUTE_EMISSIONS = [197.23, 7.32, 54.56, 16, 0];

export const DAILY_COMMUTE_DISTANCE_KM = 30;
export const DAILY_COMMUTE_TIME_MINUTES = 62;

export const WORK_DAYS_PER_MONTH = 19;

export const WORK_DAYS = 5;
